var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWheel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "43.5 115 25 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#121212",
    d: "M61.1 128.7v-.2l6.8-2.6c-.3-1.1-.7-2.2-1.3-3.2l-6.9 2.6c-.4-.4-.8-.7-1.3-.9l-.6-.3v-7.5c-.2 0-.4-.1-.6-.1-.3-.1-.6-.1-1-.1H55c-.2 0-.4 0-.6.1v7.6c-.1 0-.2.1-.4.2-.7.3-1.2.8-1.7 1.3l-7.3-2.1c-.5 1-.8 2.2-1 3.4l7.2 2.1c0 .8.3 1.5.6 2.2l-4.7 6.1c.2.3.5.5.8.8.5.5 1.1.9 1.7 1.2.1 0 .2.1.3.1l4.7-6c.5.2 1 .3 1.6.3.6 0 1.1-.1 1.6-.3l4.5 5.7c1-.6 2-1.3 2.7-2.2l-4.5-5.7c.3-.7.6-1.6.6-2.5zm-5 2.7c-1.5 0-2.7-1.2-2.7-2.7 0-1.5 1.2-2.7 2.7-2.7 1.5 0 2.7 1.2 2.7 2.7 0 1.5-1.2 2.7-2.7 2.7z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheel);
export default __webpack_public_path__ + "static/media/wheel.4b6b5e5cae819ba04b44db49b13d5938.svg";
export { ForwardRef as ReactComponent };